import { useState, useCallback } from "react";
/**
 * @example
 * const [value, toggle, toggleOn, toggleOff]  = useToggle(false);
 *
 * @param {Boolean} initialValue
 */
export default (function (initialValue, _a) {
    if (initialValue === void 0) { initialValue = false; }
    var _b = _a === void 0 ? {} : _a, on = _b.on, off = _b.off, onToggle = _b.toggle;
    var _c = useState(!!initialValue), value = _c[0], setToggle = _c[1];
    var toggle = useCallback(function () {
        setToggle(function (oldValue) {
            var nextValue = !oldValue;
            if (onToggle)
                onToggle(nextValue);
            if (on && nextValue)
                on();
            if (off && !nextValue)
                off();
            return nextValue;
        });
    }, []);
    var toggleOn = useCallback(function () {
        setToggle(true);
        if (on)
            on();
    }, []);
    var toggleOff = useCallback(function () {
        setToggle(false);
        if (off)
            off();
    }, []);
    return [value, toggle, toggleOn, toggleOff];
});
